import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import {
  getAllStoresApi,
  getPickupStoresApi,
  RequestType
} from 'src/services/oms'
import type { MetaStateInReducer } from '../meta'

export const fetchAllStoresAction = createAsyncThunk(
  '@stores/fetchAllStores',
  async ({
    req,
    isServer,
    menuId
  }: {
    req?: RequestType
    isServer?: boolean
    menuId: string
  }) => {
    const result = await getAllStoresApi({ req, isServer, menuId })
    return result.data
  }
)

export const fetchStoreInfoAction = createAsyncThunk(
  '@stores/fetchStoreInfo',
  async ({ storeId }: { storeId: string }, thunkApi) => {
    const state = thunkApi.getState() as MetaStateInReducer
    const {
      detailMenuSite: {
        data: { storeOrderId }
      }
    } = state['@meta']
    const result = await getPickupStoresApi({ storeOrderId, storeId })
    return result.data
  }
)

export const setStoresCache = createAction(
  '@meta/setStoresCache',
  (params) => {
    return {
      payload: params
    }
  }
)
